// extracted by mini-css-extract-plugin
module.exports = {"logo":"Login_logo__1_Dfc","form":"Login_form__Cuyps","alternatives":"Login_alternatives__2Z5sq","link":"Login_link__1jEwl","register":"Login_register__4mzQY"};